const actionTypes = {
  setDescription: 'SET_DESCRIPTION',
  setClientDetails: 'SET_CLIENT_DETAILS',
  addContent: 'ADD_CONTENT',
  setContent: 'SET_CONTENT',
  setErrors: 'SET_ERRORS',
  setLoading: 'SET_LOADING',
  getContentCategoriesSuccess: 'GET_CONTENT_CATEGORIES_SUCCESS',
  getContentCategoriesLoading: 'GET_CONTENT_CATEGORIES_LOADING',
  getContentCategoriesError: 'GET_CONTENT_CATEGORIES_ERROR',
  setProgrammeDetails: 'SET_PROGRAMME_DETAILS',
};

export default actionTypes;
